export function toIsoDate(rawValue: string): string {
  const date = new Date(rawValue);
  return Number.isNaN(date.getTime()) ? rawValue : date.toISOString();
}
